import { validateForm } from '../utils';
import useUser from '../../../user';
import { getFormValues, getStepFieldValue } from '../utils';
import { useSelector, useDispatch } from 'react-redux';
import { keyUpdatedAction } from '../../../../redux/actions/local';

const validator = require('validator');

const useRegister = () => {
  const dispatch = useDispatch();
  const { registerAndCreateUser } = useUser();
  const { dataLinks } = useSelector(state => state.DataLinks);

  const registerUser = async ({
    step,
    history,
    documents,
    selections,
    local,
    data,
    params
  }) => {
    let payload = {};
    if (step.formId) {
      if (!validateForm({ formId: step.formId })) {
        console.error(`${step.formId} is not valid`);
        return { error: 'invalid form values' };
      }

      payload = getFormValues({ formId: step.formId, returnObject: true });
    }

    step.fields
      ?.filter(f => f.value.toString().indexOf('{data.') === -1)
      .forEach(stepField => {
        const fieldValue = getStepFieldValue({
          stepField,
          underlyingField: {
            type: stepField.fieldType
          },
          selections,
          history,
          documents,
          local,
          dataLinks,
          data,
          params
        });

        if (stepField.name?.trim().length > 0) {
          // make sure text fields are no co-erced to numbers if the contain number strings
          if (stepField?.type === 'string' && fieldValue?.toString) {
            payload[stepField.name] = fieldValue.toString();
          } else {
            payload[stepField.name] = fieldValue;
          }
        } else {
          // dynamic field name
          payload[stepField.dynamicFieldName] = fieldValue;
        }
      });

    if (!payload.password || payload.password.trim().length === 0) {
      const chars =
        '0123456789abcdefghijklmnopqrstuvwxyz!#$&ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      for (var i = 0; i <= 8; i++) {
        var randomNumber = Math.floor(Math.random() * chars.length);
        payload.password += chars.substring(randomNumber, randomNumber + 1);
      }
    }

    if (
      !validator.isStrongPassword(payload.password, {
        minLength: 8,
        minLowercase: 0,
        minUppercase: 0,
        minNumbers: 0,
        minSymbols: 0
      })
    ) {
      console.error('Password is not strong enough');
      return {
        error: `Password is not strong enough. Must be at least 8 characters with at least one of each of: an upper case letter, a lower case letter and a number`
      };
    }

    const createUserResult = await registerAndCreateUser(payload);

    dispatch(keyUpdatedAction('registerUserResult', createUserResult));

    if (createUserResult.code) {
      return { error: createUserResult.message, code: createUserResult.code };
    } else {
      return createUserResult;
    }
  };

  return {
    registerUser
  };
};

export default useRegister;
